import styled from 'styled-components';

interface PropsContent {
  active: boolean;
}
export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  .subHeader {
    display: flex;
    gap: 1rem;
    align-items: center;

    svg {
      height: 2rem;
      fill: ${({ theme }) => theme.colors.secondary};
    }

    h1 {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 1.3rem;
      margin: 0;
      font-weight: 300;
    }
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const Form = styled.form<PropsContent>`
  h2 {
    margin: 1rem 0 0 0;
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.text};
    font-weight: 300;
  }

  p {
    font-weight: 300;
    color: ${({ theme }) => theme.colors.text};
    font-size: 1.1rem;
    padding: 0.3rem 0.3rem 0.3rem 0;
  }

  .MuiInput-input {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    padding-left: 0.3rem;
  }

  .containerName {
    margin: 0 0 0.5rem 0;
    display: flex;
  }

  .AddCheckedTypeProfile {
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.primary};
    margin-top: 1rem;

    .checkboxControl {
      display: flex;
      align-items: center;
      margin-left: -0.3rem;
    }
  }

  .TypeProfile {
    display: flex;
    gap: 1rem;

    div {
      display: flex;
      width: 100%;
    }

    .divGrid {
      display: flex;
      width: 100%;
      gap: 1rem;
      flex-direction: column;

      .contentProfile {
        display: flex;

        .profile {
          display: flex;
        }
      }
    }

    .profiles {
      margin-left: 3rem;

      p {
        margin: 0 0 0 2rem;
      }
    }

    .contentTypeOption {
      position: relative;

      .contentOptionProfile {
        display: ${({ active }) => (active ? 'flex' : 'none')};
        background-color: ${({ theme }) => theme.colors.background};
        justify-content: flex-end;
        position: absolute;
        padding: 0.7rem;
        box-shadow: 0px 3px 6px #00000029;
        z-index: ${({ active }) => (active ? '10' : '0')};

        div:nth-child(1) {
          width: 50%;
          gap: 0.9rem;
          margin: 0;
          display: grid;
          padding: 0;
        }

        div:nth-child(2) {
          display: flex;
          flex-direction: column;
          padding: 0.5rem;
          width: 50%;
          gap: 0.9rem;
          display: flex;
          border-left: 1px Solid ${({ theme }) => theme.colors.text_gray};
          max-height: 4.5rem;
          overflow-y: auto;

          ::-webkit-scrollbar {
            width: 5px;
            background-color: ${({ theme }) => theme.colors.background_white};
          }

          ::-webkit-scrollbar:horizontal {
            height: 5px;
          }

          ::-webkit-scrollbar-track,
          ::-webkit-scrollbar-track-horizontal {
            border-radius: 10px;
          }

          ::-webkit-scrollbar-thumb,
          ::-webkit-scrollbar-thumb:horizontal {
            background-color: ${({ theme }) => theme.colors.tertiary_500};
            border-radius: 10px;
          }

          .selectedProfile {
            font-size: 14px;
            font-weight: 300;
            color: ${({ theme }) => theme.colors.text_gray};
            border: none !important;
          }
        }

        button {
          display: flex;
          justify-content: flex-start;
          height: 1rem;
          font-size: 14px;
          font-family: 'Futura PT' !important;
          border: none;
          padding: 0;
          outline: 0;
          background: none;
          transition: opacity 0.2s;

          &:hover,
          &:focus {
            opacity: 0.55;
            border-bottom: 1px solid;
          }
        }

        .buttonAdd {
          display: flex;
          align-items: center;
          justify-content: space-around;
          color: ${({ theme }) => theme.colors.tertiary_500};
          font-weight: 300 !important;
          border-bottom: 1px solid;
          max-width: 5rem;

          svg {
            margin-left: 0.3rem;
          }
        }

        .buttonSelected {
          width: 21%;
          font-weight: 400 !important;
          color: ${({ theme }) => theme.colors.secondary};
        }
      }

      .inputIcon {
        .svg {
          color: ${({ theme }) => theme.colors.primary};
          transition: 0.2s;
          margin-left: -1.3rem;
          position: relative;
          align-self: center;
          transform: ${({ active }) => (active ? 'rotate(180deg)' : 'rotate(0deg)')};
        }

        .typeProfileOption {
          font-family: 'Futura PT';
          font-size: 22px;
          font-weight: 300;
          width: 100%;
          background-color: transparent;
          border: none;
          padding: 0 0.5rem;
          outline: none;
          border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
        }
      }
    }

    p {
      display: flex;
      align-items: center;
      font-weight: 300;
      font-size: 22px;
    }

    .divDropDownList {
      display: flex;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      svg {
        fill: ${({ theme }) => theme.colors.secondary};
      }

      .MuiButtonBase-root {
        font-family: 'Futura PT' !important;
      }

      .MuiInputBase-root {
        color: ${({ theme }) => theme.colors.primary}!important;
        border: none;
      }

      .MuiInputBase-root {
        font-family: 'Futura PT' !important;
        font-weight: 300;
      }

      .select-style {
        width: 100%;
        height: 1rem;
        padding: 0.5rem;
        font-size: 1rem;
        position: relative;
      }

      .MuiOutlinedInput-notchedOutline {
        border: none;
        border-bottom: 1px ${({ theme }) => theme.colors.primary} solid;
        border-radius: unset;
      }

      .MuiMenuItem-root li {
        font-size: 1rem;
      }
    }
  }

  .buttonModal {
    display: flex;
    justify-content: flex-end;
    padding: 2rem 1rem 0 1rem;
  }

  @media (max-width: 450px) {
    .contentDep,
    .contentBranch,
    .profile {
      flex-direction: column;
    }
  }
`;
